import { render } from "./Magento.vue?vue&type=template&id=449a95d9"
import script from "./Magento.vue?vue&type=script&lang=js"
export * from "./Magento.vue?vue&type=script&lang=js"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__